/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="nickName" placeholder="请输入用户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon" @click="setUserPayouts(1)">允许提现</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon" @click="setUserPayouts(0)">不可提现</el-button>
      </el-form-item> -->

    </el-form>
    <!-- <h1>还未完成</h1> -->
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border row-key="id"
      element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column align="center" prop="id" label="id" width="70" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" prop="img" label="头像" width="120">
        <template slot-scope="scope">
          <img v-if="scope.row.img" style="width: 90px;height: 90px;" :src="scope.row.img" />
          <div v-if="scope.row.img == null">暂无图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="phone" label="手机号" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.phone != null">{{ scope.row.phone }}</div>
          <div v-if="scope.row.phone == null">暂无</div>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="nickName" label="用户昵称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="realName" label="真实姓名" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="idcard" label="身份证" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" prop="state" label="账号状态" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.state == 1">正常</div>
          <div v-if="scope.row.state == 2">禁用</div>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="payouts" label="提现权限" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="!scope.row.payouts ">无</div>
          <div style="color: red;" v-if="scope.row.payouts">有</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="isConcern" label="是否关注公众号" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="!scope.row.isConcern">未关注</div>
          <div v-if="scope.row.isConcern">已关注</div>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="isSigned" label="是否签订承诺书" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="!scope.row.isSigned">未签订</div>
          <div v-if="scope.row.isSigned">已签订</div>
        </template>
      </el-table-column>


      <el-table-column align="center" prop="createTime" label="创建时间" width="150">
        <!-- <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template> -->
      </el-table-column>
      <el-table-column align="center" prop="lastLoginTime" label="上次登陆时间" width="150">
        <!-- <template slot-scope="scope">
          <div>{{ transformDate(scope.row.lastLoginTime) }}</div>
        </template> -->
      </el-table-column>
      <el-table-column align="center" label="操作" show-overflow-tooltip width="360" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button size="mini" v-if="!scope.row.isSigned" type="primary"
            @click="setUserPayouts(scope.row)">签订</el-button> -->
          <!-- <el-button size="mini " v-if="scope.row.isSigned" type="danger" @click="upAdminNo(scope.row)">取消签订</el-button> -->
          <!-- <el-button size="mini" type="danger" @click="viewDetails(scope.row)">查看详情</el-button> -->
          <el-button size="mini" type="danger" @click="getCommitmen(scope.row.id)">查看承诺书</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.state == 1"
            @click="blackoutUsers(scope.row)">拉黑用户</el-button>
          <el-button size="mini" type="success" v-else @click="blackoutUsersJ(scope.row)">解除拉黑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
       <div style="text-align: center;margin-top: 10px;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]" :page-size="size" :current-page="page" layout="total,sizes, prev, pager, next"
        :total="pageparm.total">
      </el-pagination>
    </div>


  </div>
</template>

<script>
import { query } from 'quill';
import { getAdminUserList, aduitUser, updateUserStatus, setUserPayouts, getCommitmentRecord, getBlackoutUsers, getBlackoutUsersJ } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";


// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];


export default {
  data() {
    return {
      page: 1,
      size:10,
      nickName: '',
      uploadVisible: false,
      cursorIndex: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      statusType: [
        { key: '请选择', value: 0 },
        { key: '正常', value: 1 },
        { key: '冻结', value: 2 }
      ],

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },

      keyword: "",
      mobile: "",
      from: {
        title: "",
        briefContent: "",
        content: "",
        userId: "",
        sendType: 0,
      },

      value: -1,
      options: [{
        value: -1,
        label: '全部'
      },
      {
        value: 0,
        label: '审核中'
      }, {
        value: 1,
        label: '审核通过'
      }, {
        value: 2,
        label: '审核未通过'
      }],

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    handleSizeChange(val) {
      this.size = val;
      this.getdata()
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getdata()
    },
    blackoutUsers(row) {
      console.log('row-----', row)
      console.log('row-----', this.multipleSelection)
      if (!this.multipleSelection) {
        this.$message.error('请勾选需要拉黑的用户')
        return
      }
      if (this.multipleSelection.length == 0) {
        this.$message.error('请勾选需要拉黑的用户')
        return
      }
      let selectedIds = this.multipleSelection.map(item => item.id)
      let idsa = selectedIds.join(',')
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        let data = {
          ids: idsa,
        }
        getBlackoutUsers(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 解除拉黑
    blackoutUsersJ(row) {
      if (!this.multipleSelection) {
        this.$message.error('请勾选需要拉黑的用户')
        return
      }
      if (this.multipleSelection.length == 0) {
        this.$message.error('请勾选需要拉黑的用户')
        return
      }
      let selectedIds = this.multipleSelection.map(item => item.id)
      let idsa = selectedIds.join(',')
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        let data = {
          ids: idsa,
        }
        getBlackoutUsersJ(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 启用用户


    setUserPayouts(payouts) {
      console.log('payouts', payouts)
      let selectedIds = this.multipleSelection.map(item => item.id)
      let idsa = selectedIds.join(',')

      console.log('idsa', idsa)

      this.$confirm("确定要改变这些用的提现权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          ids: idsa,
          payouts: payouts
        }
        setUserPayouts(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消通过",
        });
      });
    },
    upAdminYes(row) {
      console.log('row', row)
      this.$confirm("确定启用此用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 1
        }
        updateUserStatus(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消启用",
        });
      });
    },
    // 去往用户详情查看
    viewDetails(itemObj) {
      this.$router.push({
        path: '/User/UserDetails',
        query: {
          id: itemObj.id
        }
      })
    },
    // 禁用用户
    upAdminNo(row) {
      this.$confirm("确定禁用此用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 2
        }
        updateUserStatus(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消禁用",
        });
      });
    },
    // 审核通过
    updateYes(row) {
      console.log('row', row)
      this.$confirm("确定通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 1
        }
        aduitUser(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消通过",
        });
      });
    },

    // 审核不通过
    updateNo(row) {
      console.log('row', row)
      this.$confirm("确定不通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 2
        }
        aduitUser(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.page = 1
            this.getdata()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消不通过",
        });
      });
    },


    selectChange(e) {
      console.log('e======', e)
      this.page = 1
      this.getdata()
    },

    sexf: function (row) {
      if (row.sex == 1) {
        return "男"
      } else {
        return "女"
      }
    },

    zhuangTai: function (row) {
      if (row.status == 0) {
        return "审核中"
      } else if (row.status == 1) {
        return "审核通过"
      } else if (row.status == 2) {
        return "审核未通过"
      }
    },

    getCommitmen(id) {
      let post = {
        id: id
      }

      getCommitmentRecord(post).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          console.log("--------------")
          console.log(res)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })
    },

    // 获取数据方法
    getdata() {
      
      this.loading = true;
      let post = {
        page: (this.page - 1) * this.size,
        size: this.size,
        nickName: this.nickName,
      }

      getAdminUserList(post).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          // this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })


    },

    // 修改状态值


    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getdata(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.page = 1;
      this.getdata()
      
      // ,
      //   this.nickName = ''
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/user/User.vue